import * as NS from './namespace';

const mutations: NS.IAuthMutations = {
    SET_FORM_REQUEST(state: NS.IAuthState): void {
        state.activeFormRequest = true;
        state.failedFormRequest = false;
    },
    SET_FORM_REQUEST_FAIL(state: NS.IAuthState): void {
        state.activeFormRequest = false;
        state.failedFormRequest = true;
        state.user = undefined;
        state.token = '';
    },
    SET_FORM_REQUEST_RESET(state: NS.IAuthState): void {
        state.activeFormRequest = false;
        state.failedFormRequest = false;
    },
    SET_LOGOUT_SUCCESS(state: NS.IAuthState): void {
        state.token = '';
        state.user = undefined;
        state.activeFormRequest = false;
        state.failedFormRequest = false;
    },
    SET_LOGIN_SUCCESS(state: NS.IAuthState, payload: NS.IAuthResponse): void {
        state.token = payload.token;
        state.user = payload.user;
        state.activeFormRequest = false;
        state.failedFormRequest = false;
    },
}

/**
 * Реализация мутаций модуля аутентицикации
 */
export default mutations;